import React from 'react';
import { ChevronRight } from 'lucide-react';
import { getInitials, getStatusConfig } from '../../utils/customerUtils';

/**
 * CRM customer row. The entire row opens the customer account; users should not
 * have to choose between View Details and Schedule before seeing the record.
 */
export const CustomerRow = ({ customer, onView, theme, colors, isLast = false }) => {
  const statusConfig = getStatusConfig(customer.acquisitionStatus || customer.status);
  const StatusIcon = statusConfig.icon;
  const customerPhone = customer.phone || customer.cPhone || customer.cellPhone || 'Not provided';
  const vehicleInfo = customer.vehicle
    ? customer.vehicle
    : (customer.vehicleYear && customer.vehicleMake && customer.vehicleModel)
      ? `${customer.vehicleYear} ${customer.vehicleMake} ${customer.vehicleModel}`.trim()
      : 'Not specified';

  const open = () => onView && onView();

  return (
    <tr
      className="vc-customer-row"
      role="button"
      tabIndex={0}
      aria-label={`Open ${customer.name || 'customer'} account`}
      onClick={open}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } }}
      style={{
        borderBottom: !isLast ? '1px solid rgba(255,255,255,.05)' : 'none',
        transition: 'background .18s ease, box-shadow .18s ease, transform .18s ease',
        cursor: 'pointer',
        animation: 'fadeInUp .4s ease-out'
      }}
      onMouseOver={(e) => {
        e.currentTarget.style.background = 'rgba(59,130,246,.1)';
        e.currentTarget.style.boxShadow = 'inset 3px 0 0 #3b82f6';
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.background = 'transparent';
        e.currentTarget.style.boxShadow = 'none';
      }}
    >
      <td style={{ padding: '16px 20px' }}>
        <div style={{ display:'flex', alignItems:'center', gap:12 }}>
          <div style={{
            width:40,height:40,borderRadius:10,
            background:`linear-gradient(135deg, ${colors.primary}40 0%, ${colors.secondary}40 100%)`,
            display:'flex',alignItems:'center',justifyContent:'center',fontSize:14,fontWeight:700,color:colors.primary
          }}>{getInitials(customer.name)}</div>
          <div>
            <div style={{fontSize:14,fontWeight:700,color:theme.text}}>{customer.name || 'Unknown customer'}</div>
            <div style={{fontSize:11,color:theme.textSecondary,marginTop:3}}>Click to open account</div>
          </div>
        </div>
      </td>
      <td style={{ padding:'16px 20px', fontSize:14, color:theme.textSecondary }}>{customerPhone}</td>
      <td style={{ padding:'16px 20px', fontSize:14 }}>{vehicleInfo}</td>
      <td style={{ padding:'16px 20px' }}>
        <span style={{
          padding:'8px 14px',background:statusConfig.bg,backdropFilter:'blur(10px)',
          border:`1px solid ${statusConfig.color}40`,borderRadius:12,fontSize:12,fontWeight:600,
          color:statusConfig.color,display:'inline-flex',alignItems:'center',gap:6,
          boxShadow:`0 0 20px ${statusConfig.color}30, inset 0 1px 0 rgba(255,255,255,.1)`
        }}><StatusIcon size={14}/> {statusConfig.label}</span>
      </td>
      <td style={{padding:'16px 20px',width:40,textAlign:'right',color:'rgba(255,255,255,.35)'}}><ChevronRight size={18}/></td>
    </tr>
  );
};
